import { z } from "@/zod";
import { nonNegativeDecimalStringSchema } from "@/schemas/commonFields/numberSchema";

export const rate = z.object({
  rate_student_net: nonNegativeDecimalStringSchema,
  rate_student_tax: nonNegativeDecimalStringSchema,
  rate_kch_net: nonNegativeDecimalStringSchema,
  rate_kch_tax: nonNegativeDecimalStringSchema,
  rate_zus_net: nonNegativeDecimalStringSchema,
  rate_zus_tax: nonNegativeDecimalStringSchema,
  rate_zus_sick_net: nonNegativeDecimalStringSchema,
  rate_zus_sick_tax: nonNegativeDecimalStringSchema,
  rate_gross: nonNegativeDecimalStringSchema,
});

export type Rates = z.infer<typeof rate>;
